/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-03 12:11:44
 * @FilePath: \eu-eswop-official-site\src\locales\index.js
 * @Description:
 */

import ElementUI from 'element-ui'
import iviewDE from 'element-ui/lib/locale/lang/de.js'
import iviewEN from 'element-ui/lib/locale/lang/en.js'
import iviewES from 'element-ui/lib/locale/lang/es.js'
import iviewFR from 'element-ui/lib/locale/lang/fr.js'
import iviewIT from 'element-ui/lib/locale/lang/it.js'
// 引入 UI 框架语言配置---elementui
import iviewZH from 'element-ui/lib/locale/lang/zh-CN.js'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import de from './lang/de.js'
import en from './lang/en.js'
import es from './lang/es.js'
import fr from './lang/fr.js'
import it from './lang/it.js'
// 引入自定义语言配置
import zh from './lang/zh.js'

Vue.use(VueI18n)

const localeMapping = {
  zh: {
    name: 'ZH',
    value: 'zh',
    langFile: zh,
    iViewLangeFile: iviewZH,
    acceptLanguage: 'zh_CN'
  },
  en: {
    name: 'EN',
    value: 'en',
    langFile: en,
    iViewLangeFile: iviewEN,
    acceptLanguage: 'en_US'
  },
  es: {
    name: 'ES',
    value: 'es',
    langFile: es,
    iViewLangeFile: iviewES,
    acceptLanguage: 'es_ES'
  },
  de: {
    name: 'DE',
    value: 'de',
    langFile: de,
    iViewLangeFile: iviewDE,
    acceptLanguage: 'de_DE'
  },
  fr: {
    name: 'FR',
    value: 'fr',
    langFile: fr,
    iViewLangeFile: iviewFR,
    acceptLanguage: 'fr_FR'
  },
  it: {
    name: 'IT',
    value: 'it',
    langFile: it,
    iViewLangeFile: iviewIT,
    acceptLanguage: 'it_IT'
  }
};

// 从 URL hash 中获取 lang 参数（适用于 hash 路由）
function getLangFromURL() {
  const hash = window.location.hash;
  if (hash) {
    // 从 hash 部分提取查询参数，例如 #/shippingLable?lang=de_DE
    const queryString = hash.split('?')[1];
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      const urlLang = urlParams.get('lang');

      if (urlLang) {
        // 将 de_DE 转换为 de，zh_CN 转换为 zh 等
        const langCode = urlLang.split('_')[0];
        if (localeMapping[langCode]) {
          return langCode;
        }
      }
    }
  }
  return null;
}

const defaultLang = 'es'
const lang = getLangFromURL() || sessionStorage.getItem('lang') || defaultLang;
console.log('lang', lang);
const isES = lang === defaultLang;

// 设置后台语言的请求头
const customRequestHeader = {
  'Accept-Language': localeMapping[lang].acceptLanguage
};
const i18n = new VueI18n({
  locale: lang
})

i18n.setLocaleMessage(lang, Object.assign(localeMapping[lang]?.langFile, localeMapping[lang]?.iViewLangeFile))
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const vm = new Vue({ i18n })

// 切换语言方法
Vue.prototype.$toggleLang = (lang = defaultLang) => {
  sessionStorage.setItem('lang', lang)
  window.location.reload()
}

if (window.location.hostname !== 'localhost') {
  // 本地开发展示中文
  delete localeMapping.zh
}
export {
  customRequestHeader,
  i18n,
  isES,
  lang,
  localeMapping,
  vm}
